import styled from "styled-components";

export const PCont = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
